import script from "./taxInvoiceReport.vue?vue&type=script&setup=true&lang=js"
export * from "./taxInvoiceReport.vue?vue&type=script&setup=true&lang=js"

import "./taxInvoiceReport.vue?vue&type=style&index=0&id=06348f39&scoped=true&lang=css"

import exportComponent from "/Users/saameen/Documents/www/hs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06348f39"]])

export default __exports__